import { IWeekDaysEnum } from 'types/graphqlTypes'
import * as yup from 'yup'

export const DaysOfWeekSchemaObject = {
  [IWeekDaysEnum.monday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.tuesday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.wednesday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.thursday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.friday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.saturday]: yup.boolean().nullable().default(false),
  [IWeekDaysEnum.sunday]: yup.boolean().nullable().default(false),
}

export const DaysOfWeekSchema = yup.object(DaysOfWeekSchemaObject)

export type TDaysOfWeekSchema = yup.InferType<typeof DaysOfWeekSchema>
